export const initialAddress = {
  address: "",
  city: "",
  state: "",
  zipCode: "",
  country: "",
};

export const initialResumeInfo = {
  resumeFile: "",
  createdDate: new Date(),
  jobHistory: [],
  education: [],
  objective: "",
  licenses: [],
  certifications: [],
  awards: [],
  portfolio: [],
};

export const initialTalent = {
  talent: "",
  description: "",
  score: 0,
};

export const initialTalentAssessment = {
  assessmentDate: new Date(),
  talents: [],
  prevAssessmentDate: null,
  numberOfAssessments: 0,
};

export const initialGroup = {
  groupId: null, // Replace `null` with an actual ObjectId if needed
  createDate: new Date(),
};

export const initialColleague = {
  userId: null, // Replace `null` with an actual ObjectId if needed
  createDate: new Date(),
};

export const initialUser = {
  email: "",
  clerkId: "",
  role: "Default",
  altEmail: "",
  phone: "",
  altPhone: "",
  status: "Active",
  firstName: "",
  lastName: "",
  address: initialAddress,
  ftaUser: false,
  resumeInfo: [initialResumeInfo],
  skills: [],
  talentAssessment: initialTalentAssessment,
  groups: [initialGroup],
  colleagues: [initialColleague],
  lastLoginDate: new Date(),
  createdAt: new Date(),
  updatedAt: new Date(),
};

export const initialSignUp = {
  email: "",
  firstName: "",
  lastName: "",
  zipCode: "",
  country: "United States of America (the)",
  resumeFile: null,
  howDidYouHear: "",
  referrerName: "",
  referrerEmail: "",
  otherDetails: "",
  documentReferrer: "",
};

export const initialAuthenticationState = {
  userDetails: initialUser,
  signUpDetails: initialSignUp,
  token: "",
};
